export enum Abrechnungsverfahren {
  Rechnungsdruck = 'rechnungsdruck',
  Verrechnungsstelle = 'verrechnungsstelle',
}
